// Vue
import { Vue, Component, Prop } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";
import { ScrollIndicator } from "../../../components/scroll_indicator/ScrollIndicator";
import RoundedButton from "#/components/rounded_button/RoundedButton";
import Comparison from "../filter_module/comparison/Comparison";
import ProductComparison from "../filter_module/product_comparison/ProductComparison";
@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ScrollIndicator,
    RoundedButton,
    Comparison,
    ProductComparison,
  },
})
export class StageVanSolutionModule extends ModuleBase {
  backgroundImage =
    "https://conversion-world.mercedes-benz.com/common/portal_static/ci2017/assets/images/cw-stage-van-partner-background.png";

  @Prop()
  instance!: any;

  currentImage = 0;
  previewImage = "";
  openCountriesModal = false;

  showCompareBar = false;
  openComparison = false;
  openProductComparison = false;

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  created() {
    window.addEventListener("scroll", this.handleScroll);
  }

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  get product() {
    return this.$store.conversionWorldProduct.current;
  }

  get isElectric() {
    if (this.instance["translation"]["disableElectric"]) {
      return false;
    }

    if (this.product) {
      return this.product.show_electric_icon;
    }

    return false;
  }

  get previewImages() {
    if (
      this.instance["optional"] &&
      this.instance["optional"]["images"] &&
      this.instance["optional"]["images"].length > 0
    ) {
      return this.instance["optional"]["images"].map((imgData) => {
        return {
          desc: imgData["title"],
          large: this.getTranslatedImage(imgData["image"], this.lang, "large"),
          medium: this.getTranslatedImage(
            imgData["image"],
            this.lang,
            "medium"
          ),
          small: this.getTranslatedImage(imgData["image"], this.lang, "small"),
          xlarge: this.getTranslatedImage(
            imgData["image"],
            this.lang,
            "xlarge"
          ),
        };
      });
    }

    if (this.product) {
      return this.product.preview_images;
    }

    return [];
  }

  get branchenName() {
    if (this.product && this.product.branche) {
      return this.product.branche.name;
    }

    return "";
  }

  get productName() {
    if (this.product) {
      return this.product.name;
    }

    return "";
  }

  get buildDuration() {
    if (this.instance["optional"] && this.instance["optional"]["buildtime"]) {
      return this.instance["optional"]["buildtime"];
    }

    if (this.product) {
      return this.product.technical_data.build_duration;
    }

    return "";
  }

  get secondPreviewAvailable() {
    if (this.previewImages[1]) return true;
    return false;
  }

  get priceText() {
    if (this.product) {
      if (this.product.price.no_information) {
        return this.instance["translation"]["price_no_info"];
      }

      return (
        this.instance["translation"]["price_ab"] + " " + this.product.price.text
      );
    }

    return "";
  }

  get countries() {
    let text = "";
    if (this.product) {
      if (this.product.technical_data.countries.length == 1) {
        return this.product.technical_data.countries[0].name;
      }

      for (let i = 0; i < 5; i++) {
        if (this.product.technical_data.countries[i]) {
          text += this.product.technical_data.countries[i].name + ", ";
        }
      }

      if (this.product.technical_data.countries.length <= 5) {
        text = text.slice(0, text.length - 2);
      }
    }
    return text;
  }

  get showCompareProductsCount() {
    return this.$store.conversionWorld.compareProducts.length > 0
      ? true
      : false;
  }

  public handleScroll(e) {
    if (this.$el.getBoundingClientRect().bottom < 0) {
      this.showCompareBar = true;
    } else {
      this.showCompareBar = false;
    }
  }

  public handleBack($event) {
    $event.preventDefault();
    window.history.back();
  }

  public handleChangePreview(index) {
    this.currentImage = index;
  }

  public handleShowAll($event) {
    $event.preventDefault();
    this.openCountriesModal = true;
  }

  public closeCountriesModal() {
    this.openCountriesModal = false;
  }

  public handleShowComparison() {
    this.openComparison = !this.openComparison;
  }

  public handleProductCompare() {
    this.openProductComparison = !this.openProductComparison;
    this.$store.ui.setShowProductComparison(this.openProductComparison);
    this.$emit("comparisonOpen", this.openProductComparison);
  }
}
